import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { store } from "../store";
import Tab from "./Tab";
import { CurrentTheme } from "theme";

export default observer(
  class Header extends Component {
    render() {
      const { isSentTab } = store;

      return (
        <Wrapper>
          <Tab
            key="scheduled"
            name="Scheduled"
            selected={!isSentTab}
            onClick={() => (store.isSentTab = false)}
          />
          <Tab
            key="sent"
            name="Post Sent"
            selected={isSentTab}
            onClick={() => (store.isSentTab = true)}
          />
        </Wrapper>
      );
    }
  }
);

const Wrapper = styled.div`
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  display: flex;
  & > div:first-child {
    border-right: 1px solid ${props => props.theme.panelBorder};
    border-radius: 4px 0 0 0;
  }
`;



// WEBPACK FOOTER //
// ./src/module-schedule/header/HeaderWithStoreQuery.js